import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ShieldAlert } from "lucide-react";
import { AGE_KEY, RETENTION_DAYS } from "@/lib/legal";

const FREE_PATHS = ["/admin", "/sign-", "/aszf", "/adatvedelem"];

export default function AgeGate() {
  const { pathname } = useLocation();
  const [ok, setOk] = useState(() => !!localStorage.getItem(AGE_KEY));
  const [agree, setAgree] = useState(false);
  const [declined, setDeclined] = useState(false);
  if (ok || FREE_PATHS.some((p) => pathname.startsWith(p))) return null;

  const accept = () => {
    if (!agree) return;
    localStorage.setItem(AGE_KEY, new Date().toISOString());
    setOk(true);
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-[#0F0C1B]/85 backdrop-blur-xl p-4" data-testid="age-verification-modal">
      <div className="rise relative w-full max-w-md rounded-3xl border border-white/10 bg-[#1A152E] p-8 shadow-[0_0_60px_rgba(255,59,108,0.25)]">
        <div className="absolute -top-6 left-8 rotate-[-6deg] rounded-2xl bg-[#FFD600] px-4 py-2 font-display text-2xl font-black text-[#0F0C1B]">18+</div>
        {declined ? (
          <div className="pt-4 text-center" data-testid="age-declined-message">
            <ShieldAlert className="mx-auto mb-4 h-12 w-12 text-[#FF3B6C]" />
            <h2 className="font-display text-2xl font-bold">Sajnáljuk!</h2>
            <p className="mt-2 text-muted-foreground">Az oldal csak 18 év felettiek számára elérhető.</p>
          </div>
        ) : (
          <>
            <h2 className="pt-4 font-display text-3xl font-extrabold">Elmúltál már 18?</h2>
            <p className="mt-3 text-sm leading-relaxed text-muted-foreground">
              Az easysweetchat.com-on idegenekkel beszélgethetsz szövegben, hangon és videón. Az oldal kizárólag 18 év felettieknek szól.
              A beszélgetéseket (üzenetek, csatolt fájlok, IP-cím, böngészőadatok, belépési idő) moderálás és visszaélések kivizsgálása
              céljából {RETENTION_DAYS} napig tároljuk, az üzemeltető megtekintheti őket. A hang- és videóképet nem rögzítjük.
            </p>
            <label className="mt-5 flex cursor-pointer items-start gap-3 text-sm" data-testid="terms-accept-label">
              <input type="checkbox" checked={agree} onChange={(e) => setAgree(e.target.checked)} data-testid="terms-accept-checkbox"
                className="mt-0.5 h-5 w-5 shrink-0 accent-[#FF3B6C]" />
              <span>
                Kijelentem, hogy elmúltam 18 éves, elfogadom az{" "}
                <Link to="/aszf" target="_blank" className="font-semibold text-[#00F0FF] underline" data-testid="age-terms-link">ÁSZF-et</Link>, és
                megismertem az{" "}
                <Link to="/adatvedelem" target="_blank" className="font-semibold text-[#00F0FF] underline" data-testid="age-privacy-link">Adatkezelési tájékoztatót</Link>.
              </span>
            </label>
            <div className="mt-6 flex flex-col gap-3 sm:flex-row">
              <button data-testid="confirm-18-button" onClick={accept} disabled={!agree}
                className="flex-1 rounded-full bg-gradient-to-r from-pink-500 via-purple-600 to-indigo-600 px-6 py-3 font-bold text-white transition-transform hover:scale-[1.03] active:scale-95 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:scale-100">
                Belépés
              </button>
              <button data-testid="decline-18-button" onClick={() => setDeclined(true)}
                className="rounded-full border border-white/15 px-6 py-3 font-semibold text-muted-foreground transition-colors hover:bg-white/5">
                Nem múltam el 18
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
